import { css } from '@emotion/core';
import { findLastIndex, unset } from 'lodash';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../utils/constants';

export const commonCssbutton = css({
  marginTop: '40px',
  '.CTA-button': {
    [MediaQueries.md]: {
      width: '100%',
    },
    [MediaQueries.sm]: {
      width: '100%',
    },
  },
});
export const commonCss = css({});

export const DarkModeCss = css({});

export const LightModeCss = css({});
